export default __webpack_public_path__ + "static/media/phone_talk.2a407591.jpg";